(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name patternLimitation.factory:PatternLimitationRequestFactory
	 *
	 * @description
	 *
	 */
	angular.module('patternLimitation').factory(
			'PatternLimitationRequestFactory', PatternLimitationRequestFactory);

	function PatternLimitationRequestFactory() {

		// ----declare DTOs------

		function PatternLimitationSearchRequestDTO() {
			this.patternName = null;
			this.crewType = null;
		}

		function PatternLimitationDTO() {
			this.patternLimitationId=null;
			this.crewType = null;
			this.maxNoOfPatterns = 0;
			this.patternNames = [];
			this.addPriorToLeaveInactive = false;
			this.noOfOffBeforePattern = 0;
			this.noOfOffAfterPattern = 0;
			this.conditionOr = null;
		}

		function PatternNameDTO() {
			this.patternName = null;
			this.id = null;
			this.patternLimitationId = null;
			this.version = null;
		}

		function PatternLimitationDeleteRequest() {
			this.limitationList = [];
		}

		function PatternLimitationDeleteDTO() {
			this.patternLimitationId = null;
			this.version = null;
		}

		function PatternLimitationSaveDTO() {
			this.patternName;
			this.version;
			this.patternLimitationId;
			this.maxNumberOfPattern;
			this.crewTypeCode;
			this.offBeforePattern;
			this.offAfterPattern;
			this.conditionOr;
		}

		// ----Define Function --------
		// setter and setters pattern limitation search request
		function GetPatternLimitationSearchRequest() {
			return new PatternLimitationSearchRequestDTO();
		}

		function GetFormattedPatternLimitationSearchRequest(searchParam) {
			var patternLimSearchReq = new PatternLimitationSearchRequestDTO();
			if (!!searchParam.crewType) {
				patternLimSearchReq.crewType = searchParam.crewType.crewTypeCode;
			}
			if (searchParam.patternName != null
					&& searchParam.patternName != undefined
					&& searchParam.patternName != "") {
				patternLimSearchReq.patternName = searchParam.patternName;
			}
			return patternLimSearchReq;
		}

		// getter and setter of pattern limitation dto
		function GetPatternLimitationDTO() {
			return new PatternLimitationDTO();
		}

		function GetFormattedPatternLimitationDTO(selectedPatternLimitation) {
			var patternLimitation = new PatternLimitationDTO();
			patternLimitation.patternLimitationId = selectedPatternLimitation.patternLimitationId;
			patternLimitation.maxNoOfPatterns = (!!selectedPatternLimitation.maxNoOfPatterns) ? selectedPatternLimitation.maxNoOfPatterns
					: 0;
			patternLimitation.patterns = [];
			patternLimitation.addPriorToLeaveInactive = selectedPatternLimitation.addPriorToLeave == "N" ? true
					: false;
			patternLimitation.noOfOffBeforePattern = (!!selectedPatternLimitation.noOfOffBeforePattern) ? selectedPatternLimitation.noOfOffBeforePattern
					: 0;
			patternLimitation.noOfOffAfterPattern = (!!selectedPatternLimitation.noOfOffAfterPattern) ? selectedPatternLimitation.noOfOffAfterPattern
					: 0;
			patternLimitation.conditionOr = selectedPatternLimitation.conditionOr;
			return patternLimitation;
		}

		// get pattern names
		function GetFormattedPatternNames(patternNameList, index) {
			var i = (!!index && index > 0) ? index : 0;
			var patternNames = [];
			if (!!patternNameList) {
				var pattern = null;
				for (var j=0; j < patternNameList.length; j++) {
					pattern = new PatternNameDTO();
					pattern.patternName = patternNameList[j].patternName;
					pattern.id = i;
					if(!!patternNameList[j].patternLimitationId){
						pattern.patternLimitationId = patternNameList[j].patternLimitationId;
					}
					if(!!patternNameList[j].version || patternNameList[j].version===0){
						pattern.version = patternNameList[j].version;
					}
					patternNames.push(pattern);
					i++;
				}
			}
			return patternNames;
		}

		// getter and setter of pattern limitation delete request
		function GetPatternLimitationDeleteRequest() {
			return new PatternLimitationDeleteRequest();
		}

		function GetFormattedPatternLimitationDeleteRequest(
				selectedPatternLimitation) {
			var deleteReq = new PatternLimitationDeleteRequest();
			if (!!selectedPatternLimitation) {
				var deleteReqDTO = null;
				for (var i = 0; i < selectedPatternLimitation.patternNames.length; i++) {
					deleteReqDTO = new PatternLimitationDeleteDTO();
					deleteReqDTO.patternLimitationId = selectedPatternLimitation.patternNames[i].patternLimitationId;
					deleteReqDTO.version = selectedPatternLimitation.patternNames[i].version;
					deleteReq.limitationList.push(deleteReqDTO);
				}
			}
			return deleteReq;
		}

		// getter and setter of pattern limitation delete request
		function GetFormattedPatternLimitationSaveRequest(
				selectedPatternLimitation) {
			var patternLimitationSaveReq = [];
			var patternLimitationSaveDTO = null;
			for (var i = 0; i < selectedPatternLimitation.patternNames.length; i++) {
				patternLimitationSaveDTO = new PatternLimitationSaveDTO();
				patternLimitationSaveDTO.patternName = selectedPatternLimitation.patternNames[i].patternName;
				patternLimitationSaveDTO.version = selectedPatternLimitation.patternNames[i].version;
				patternLimitationSaveDTO.patternLimitationId = selectedPatternLimitation.patternNames[i].patternLimitationId;
				patternLimitationSaveDTO.maxNumberOfPattern = selectedPatternLimitation.maxNoOfPatterns;
				patternLimitationSaveDTO.crewTypeCode = selectedPatternLimitation.crewType.crewTypeCode;
				patternLimitationSaveDTO.offBeforePattern = selectedPatternLimitation.noOfOffBeforePattern;
				patternLimitationSaveDTO.offAfterPattern = selectedPatternLimitation.noOfOffAfterPattern;
				patternLimitationSaveDTO.addPriorToLeave = !selectedPatternLimitation.addPriorToLeaveInactive;
				patternLimitationSaveDTO.conditionOr = selectedPatternLimitation.conditionOr;
				patternLimitationSaveReq.push(patternLimitationSaveDTO);
			}
			return patternLimitationSaveReq;
		}

		// map services to return
		return {
			getPatternLimitationSearchRequest : GetPatternLimitationSearchRequest,
			getFormattedPatternLimitationSearchRequest : GetFormattedPatternLimitationSearchRequest,
			getPatternLimitationDTO : GetPatternLimitationDTO,
			getFormattedPatternLimitationDTO : GetFormattedPatternLimitationDTO,
			getFormattedPatternNames : GetFormattedPatternNames,
			getPatternLimitationDeleteRequest : GetPatternLimitationDeleteRequest,
			getFormattedPatternLimitationDeleteRequest : GetFormattedPatternLimitationDeleteRequest,
			getFormattedPatternLimitationSaveRequest : GetFormattedPatternLimitationSaveRequest
		}

	}
})();
